import React from "react";
import { styles } from "./leadsStyles";

export function LeadsEmailTab({ vm }) {
  const {
    emailNotificationMessage,
    emailNotificationStatus,
    newEmailInput,
    setNewEmailInput,
    leadNotificationEmails,
    addEmailToNotificationList,
    removeEmailFromNotificationList,
    saveLeadNotificationEmails,
  } = vm;
  return (
              <div style={styles.webhookContainer}>
                <h3 style={styles.sectionTitle}>Notificações por email</h3>
                <p style={styles.webhookDescription}>
                  Cadastre emails para receber uma notificação a cada novo lead capturado. Útil para quem não usa CRM ou quer acompanhar os leads por email além do CRM.
                </p>
                
                {emailNotificationMessage && (
                  <div style={{
                    ...styles.message,
                    ...(emailNotificationStatus === "success" ? styles.messageSuccess : styles.messageError)
                  }}>
                    {emailNotificationMessage}
                  </div>
                )}
                
                <div style={styles.formGroup}>
                  <label style={styles.label}>Adicionar email:</label>
                  <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                    <input
                      type="email"
                      value={newEmailInput}
                      onChange={(e) => setNewEmailInput(e.target.value)}
                      onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), addEmailToNotificationList())}
                      placeholder="email@exemplo.com"
                      style={{ ...styles.input, flex: "1", minWidth: "200px" }}
                    />
                    <button onClick={addEmailToNotificationList} style={styles.button}>
                      Adicionar
                    </button>
                  </div>
                </div>
                
                <div style={styles.formGroup}>
                  <label style={styles.label}>Emails cadastrados:</label>
                  {leadNotificationEmails.length === 0 ? (
                    <p style={styles.helperText}>Nenhum email cadastrado. Adicione acima para receber notificações.</p>
                  ) : (
                    <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                      {leadNotificationEmails.map((email) => (
                        <li key={email} style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "8px" }}>
                          <span style={{ color: "#e2e8f0", flex: 1 }}>{email}</span>
                          <button
                            onClick={() => removeEmailFromNotificationList(email)}
                            style={{ ...styles.buttonDanger, padding: "6px 12px", fontSize: "12px" }}
                          >
                            Remover
                          </button>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                
                <div style={styles.buttonGroup}>
                  <button onClick={saveLeadNotificationEmails} style={styles.button}>
                    Salvar configuração
                  </button>
                </div>
              </div>
  );
}
